import { bindClient } from "@spiriidk/utils";
import { useQuery } from "@tanstack/react-query";
import { getLiveStatus } from "connect-api/opcenter/api/get-live-status";

import { typedFetch } from "~/api/typed-fetch";

const systemStatusApi = bindClient({ getLiveStatus }, typedFetch);

const QUERY_KEY = "opcenter";
const STALE_TIME = 5 * 60 * 1000;

function useSystemStatus() {
  const query = useQuery({
    queryKey: [QUERY_KEY],
    queryFn: ({ signal }) => systemStatusApi.getLiveStatus(signal),
    staleTime: STALE_TIME,
  });

  return {
    status: query.data?.status,
    pageUrl: query.data?.page.url,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}

export { useSystemStatus };
